<template>
  <nav id="navbar-main">
    <div class="filter-group">
      <div class="navbar-item label-wrapper" v-if="isInternal">
        <b-field label="Project" label-position="on-border" type="is-primary">
          <b-select v-model="currentProjectIndex" :disabled="projects.length < 2">
            <option v-for="(option, index) in projects" :value="index" :key="index">
              {{ option.project }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="navbar-item label-wrapper" v-if="schools">
        <b-field label="School" label-position="on-border" type="is-primary">
          <b-select :placeholder="schools[0].school" :disabled="schools.length === 1" v-model="currentSchoolIndex"
            @input="selectSchool(currentSchoolIndex)">
            <option v-for="(option, index) in schools" :value="index" :key="index">
              {{
                option.school && option.school !== "null"
                  ? option.school
                  : project
              }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="navbar-item" v-if="schools">
        <b-button class="filter-button" @click="filterResults">Load School
        </b-button>
      </div>

      <div class="navbar-item" v-if="isInternal">
        <b-button class="filter-button" @click="refreshProjects">Refresh Projects
        </b-button>
      </div>

      <div style="width: 100%;"></div>

      <subject-select-bar :label="'Subject Select'" class="navbar-item"></subject-select-bar>

      <div class="navbar-item" v-if="grades.length > 0">
        <b-field :label="contextualGradeLabel()" label-position="on-border" type="is-primary">
          <b-select :placeholder="grades[0]" :disabled="grades.length === 1" v-model="currentGradeIndex">
            <option v-for="(option, index) in grades" :value="index" :key="index">
              {{
                option == 13
                  ? "Adult"
                  : contextualSpecificGradeAndLabelMin(option)
              }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="navbar-item" v-if="classes.length > 0">
        <b-field label="Class" label-position="on-border" type="is-primary">
          <b-select :placeholder="classes.length > 1 ? 'ALL' : classes[0]" :disabled="classes.length === 1"
            v-model="currentClassIndex">
            <option :value="-1">
              ALL
            </option>
            <option v-for="(option, index) in classes" :value="index" :key="index">
              {{ option }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="navbar-item" v-if="threads.length > 0">
        <b-field label="Journey" label-position="on-border" type="is-primary">
          <b-select :placeholder="threads[0]" v-model="currentThreadIndex" :disabled="false">
            <option v-for="(option, index) in threads" :value="index" :key="index">
              {{ option }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="navbar-item" v-if="
        filterValues.tutors.filterBy && filterValues.tutors.value.length > 0
      ">
        <b-field label="Tutor" label-position="on-border" type="is-primary">
          <b-select :placeholder="filterValues.tutors.value.length > 1
              ? 'ALL'
              : filterValues.tutors.value[0].name
            " :disabled="filterValues.tutors.value.length === 1" v-model="currentTutorIndex">
            <option :value="-1">
              ALL
            </option>
            <option v-for="(option, index) in filterValues.tutors.value" :value="index" :key="index">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <search-bar :label="'Search'" :studentsList="studentsList" class="navbar-item"></search-bar>
    </div>

    <!-- <div class="navbar-item text-label" v-if="adminName">
      <div class="avatar">{{ adminName }}</div>
    </div> -->
  </nav>
</template>

<script>
// import NavBarMenu from "@/modules/global/components/navbar/NavbarMenu.vue";
// import NavItem from "@/modules/global/components/navbar/NavItem.vue";
import localizationMixin from "@/modules/global/mixins/localizationMixin.js";
import SearchBar from "@/modules/global/components/SearchbarComponent.vue";
import SubjectSelect from "@/modules/global/components/SubjectSelectComponent.vue";
import UsersTableComponent from "@/modules/users/components/UsersTableComponent.vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import threadNames from "@/utils/thread-names.js";

export default {
  name: "NavBarLayout",
  components: {
    // NavBarMenu,
    "search-bar": SearchBar,
    "subject-select-bar": SubjectSelect
    // "nav-item": NavItem
  },
  data() {
    return {
      isMenuNavBarActive: false,
      currentProjectIndex: -1,
      currentSchoolIndex: 0,
      currentGradeIndex: 0,
      currentClassIndex: -1,
      currentThreadIndex: 0,
      currentTutorIndex: -1,
      oneSchoolAutoLoadFetched: false
    };
  },
  mixins: [localizationMixin],
  computed: {
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? "close" : "dots-vertical";
    },
    menuToggleMobileIcon() {
      return "forwardburger";
    },
    ...mapState({
      filterValues: state => state.globalStore.filterLists,
      isInternal: state => state.globalStore.settings.isInternal,
      isProject: state => state.globalStore.settings.isProject,
      isMatricAssessment: state =>
        state.globalStore.activeFilterParams.isMatricAssessment,
      project: state => state.globalStore.activeFilterParams.project,
      activeParams: state => state.globalStore.activeFilterParams,
      studentsList: state => state.globalStore.reflectiveData,
      projects: state => state.globalStore.projects,
      adminName: state => state.loginStore.user.name,
      currentSubject: state =>
        state.globalStore.activeFilterParams.currentSubject,
      userId: state => state.loginStore.user._id
    }),
    ...mapGetters({
      filteredList: "globalStore/getFilteredList"
    }),
    threads() {
      if (this.isMatricAssessment) {
        return this.filterValues.threads.value.matric;
      } else {
        return this.filterValues.threads.value.normal;
      }
    },
    schools() {
      if (this.project && this.filterValues.schools.filterBy) {
        const orderBySchool = this.filterValues.schools.value.map(
          schoolObject => schoolObject
        );

        const sortedBySchool = sortBy => (a, b) =>
          a[sortBy] > b[sortBy] ? 1 : -1;
        orderBySchool.sort(sortedBySchool("school"));
        return orderBySchool;
      }
      return null;
    },
    grades() {
      if (this.schools && this.schools[this.currentSchoolIndex]) {
        // console.log('schools', this.schools);
        return Object.keys(this.schools[this.currentSchoolIndex].grades).map(
          grade => {
            return grade;
          }
        );
      } else if (this.filterValues.tutors.filterBy) {
        return ["3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
      }
      return [];
    },
    classes() {
      if (
        this.schools &&
        this.schools[this.currentSchoolIndex].grades[
        this.grades[this.currentGradeIndex]
        ]
      ) {
        this.updateGradeIndex(this.currentGradeIndex);
        return this.schools[this.currentSchoolIndex].grades[
          this.grades[this.currentGradeIndex]
        ].classes;
      }
      return [];
    }
  },
  mounted() {
    if (this.$route.name) {
      this.currentProjectIndex = 0;
      this.updateActiveValues();
    }
  },
  beforeUpdate() {
    if (this.currentSchoolIndex && this.schools[this.currentSchoolIndex]) {
      this.updateCurrentSchoolName(this.schools[this.currentSchoolIndex].school);
    }
  },
  methods: {
    ...mapMutations({
      updateProject: "globalStore/updateProject",
      updateIsMatricAssessment: "globalStore/updateIsMatricAssessment",
      updateAssessmentType: "globalStore/updateAssessmentType",
      updateGradeThreads: "globalStore/updateGradeThreads",
      updateThread: "globalStore/updateThread",
      updateThreadId: "globalStore/updateThreadId",
      updateSchool: "globalStore/updateSchool",
      updateSchoolFectched: "globalStore/updateSchoolFectched",
      updateEngagementsFetched: "globalStore/updateEngagementsFetched",
      updateImprovementsFetched: "globalStore/updateImprovementsFetched",
      updateGrade: "globalStore/updateGrade",
      updateClass: "globalStore/updateClass",
      updateTutor: "globalStore/updateTutor",
      updateSchoolFlag: "globalStore/updateSchoolFlag",
      updateSearchedUser: "globalStore/updateSearchedUser",
      updateCurrentSubject: "globalStore/setCurrentSubject"
    }),
    ...mapActions({
      loading: "SET_SCREEN_LOADING",
      updateGradeIndex: "globalStore/updateGradeId",
      fetchMyLearners: "globalStore/fetchMyLearners",
      updateSchoolIndex: "globalStore/updateSchoolId",
      fetchOtherResults: "globalStore/fetchOtherResults",
      updateActiveFields: "globalStore/updateActiveFields",
      fetchEngagement: "globalStore/fetchEngagementResults",
      fetchProjectUsers: "globalStore/fetchUsersFromProject",
      fetchImprovement: "globalStore/fetchImprovementResults",
      updateCurrentSchoolName: "globalStore/updateCurrentSchoolName",
      fetchRawEngagementsData: "newEngagementsStore/fetchRawEngagementsData",
      fetchMyDetails: "loginStore/fetchMyDetails"
    }),
    async selectSchool(school) {
      await this.updateSchoolIndex(school);
      await this.updateCurrentSchoolName(
        this.schools[this.currentSchoolIndex].school
      );
      this.filterResults();
    },
    updateActiveValues() {
      this.updateThread(this.threads[this.currentThreadIndex]);
      this.updateThreadId(this.currentThreadIndex);

      this.updateSchoolIndex(this.currentSchoolIndex);
      this.updateGradeIndex(this.currentGradeIndex);

      if (this.schools && this.schools.length > 0) {
        this.updateSchool(this.schools[this.currentSchoolIndex].school);
        this.updateEngagementsFetched(
          this.schools[this.currentSchoolIndex].engagementsFetched
        );
        this.updateImprovementsFetched(
          this.schools[this.currentSchoolIndex].improvementsFetched
        );
      }

      if (this.grades.length > 0) {
        this.updateGrade(this.grades[this.currentGradeIndex]);
        let assessment = this.gradeAssessmentMap(
          this.grades[this.currentGradeIndex],
          this.currentSubject
        );
        this.updateAssessmentType(assessment);
        this.updateGradeThreads();
      }

      if (this.classes.length > 0) {
        this.updateClass(this.classes[this.currentClassIndex]);
      }

      if (this.classes.length == 0) {
        this.updateClass(null);
      }

      if (this.filterValues.tutors.filterBy) {
        this.updateTutor(
          this.filterValues.tutors.value[this.currentTutorIndex]
        );
      }

      //auto load if 1 project and school
      if (
        this.schools &&
        this.schools.length === 1 &&
        this.projects.length === 1 &&
        this.oneSchoolAutoLoadFetched === false
      ) {
        this.filterResults();
        this.oneSchoolAutoLoadFetched = true;
      }
    },
    async filterResults() {
      this.loading(true);
      const selectedGradeIndex = this.currentGradeIndex;
      let currentProject = await this.projects[this.currentProjectIndex];
      this.updateActiveFields(currentProject);
      this.reload();
      const fetchParams = {
        project: currentProject.project,
        fetchBySchool: true,
        school: this.schools[this.currentSchoolIndex].school,
        schoolIndex: this.currentSchoolIndex
      };

      let usersRequest = await this.fetchProjectUsers(fetchParams);
      // console.log('usersRequest', usersRequest);

      this.reloadGrade(selectedGradeIndex);
      this.loading(false);

      await this.fetchRawEngagementsData(currentProject.project);

      // console.log(newEngagementsDataRequest);

      if (usersRequest) {
        await this.fetchOtherResults({
          filter: this.activeParams,
          index: this.currentProjectIndex,
          schoolIndex: this.currentSchoolIndex,
          fetchBySchool: true
        });

        await this.fetchImprovement({
          filter: this.activeParams,
          index: this.currentProjectIndex,
          schoolIndex: this.currentSchoolIndex,
          fetchBySchool: true
        });

        //force reload of loading tabs
        this.reloadGrade(selectedGradeIndex);
      }
    },
    async refreshProjects() {
      // console.log("user", this.$store.state.loginStore.user);
      this.loading(true);
      const selectedGradeIndex = this.currentGradeIndex;
      await this.fetchMyDetails(this.userId);
      this.reloadGrade(selectedGradeIndex);
      this.loading(false);
    },
    reloadGrade(selectedGradeIndex) {
      if (this.grades && this.grades.length >= selectedGradeIndex + 1) {
        this.currentGradeIndex = selectedGradeIndex;
      }
      this.reload();
    },
    gradeAssessmentMap(grade, subject) {
      if (this.isMatricAssessment) {
        return "MATHS_MATRIC_FOUNDATIONS";
      }
      if (subject === "ENGLISH") {
        switch (parseInt(grade)) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
            return "ENGLISH_SENIOR_PRIMARY";
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
            return "ENGLISH_JUNIOR_HIGH";
          default:
            // eslint-disable-next-line no-console
            // console.log("English assessment not found");
            return "ENGLISH_JUNIOR_HIGH";
        }
      } else {
        switch (parseInt(grade)) {
          case 1:
          case 2:
          case 3:
          case 4:
            return "MATHS_JUNIOR_PRIMARY";
          case 5:
          case 6:
          case 7:
            return "MATHS_SENIOR_PRIMARY";
          case 8:
          case 9:
            return "MATHS_JUNIOR_HIGH";
          case 10:
          case 11:
          case 12:
            return "MATHS_JUNIOR_HIGH";
          case 13:
            return "MATHS_ADULT_NUMERACY";
          default:
            // eslint-disable-next-line no-console
            // console.log("Maths assessment not found");
            return "MATHS_JUNIOR_HIGH";
        }
      }
    },
    menuToggleMobile() {
      this.$store.commit("asideMobileStateToggle");
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive;
    },
    myProfile() {
      this.$buefy.snackbar.open({
        message: "Feature will be available soon!",
        queue: false
      });
    },
    reload() {
      this.updateActiveValues();
    }
  },
  watch: {
    $route: {
      handler: function (to, from) {
        if (!from.name && to.name) {
          this.currentProjectIndex = 0;
          this.updateActiveValues();
        }
      }
    },
    studentsList: {
      handler: function () {
        if (this.projects && this.projects.length > 1) {
          this.currentGradeIndex = 0;
          this.reload();
        }
      }
    },
    currentProjectIndex: {
      handler: async function () {
        //force ui to reload class when switching projects
        this.currentClassIndex = -1;
        this.reload();
        //set defaults for new project
        this.currentSchoolIndex = 0;
        this.currentGradeIndex = 0;
        this.currentClassIndex = 0;
        let currentProject = this.projects[this.currentProjectIndex];
        this.updateActiveFields(currentProject);
        this.updateActiveValues();
        this.reload();
      }
    },
    currentSchoolIndex: {
      handler: function () {
        this.currentGradeIndex = 0;
      }
    },
    currentGradeIndex: {
      handler: function () {
        if (this.classes && this.classes.length > 1) {
          this.currentClassIndex = -1;
        } else {
          this.currentClassIndex = 0;
        }
        this.reload();
      }
    },
    currentClassIndex: {
      handler: function () {
        this.reload();
      }
    },
    currentThreadIndex: {
      handler: function () {
        this.reload();
      }
    }
  }
};
</script>

<style lang="scss"></style>
